import {constants} from "../../../constants";

export default class DepositCanceled {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.depositCanceled();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.EXCITE:
                event["depositCanceled"] = this._default
                break;
            default:
                event["depositCanceled"] = this._default
        }

        return event;
    }
}
